module.exports = __webpack_public_path__ + "img/c-thermometer-img1-2.f0a8fab3.png";